import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useLocation } from "react-router-dom";

export default function MapPage() {
  const location = useLocation();
  const { lat, long } = location.state || { lat: 37.5498, long: 45.0786 };

  // تعریف آیکون
  const emptyIcon = new L.Icon({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
  });

  const [position, setPosition] = useState({ lat: lat, lng: long });

  const mapRef = useRef(null);

  useEffect(() => {
    const map = L.map(mapRef.current).setView([position.lat, position.lng], 13);

    L.tileLayer(
      "https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
      {
        maxZoom: 20,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
      }
    ).addTo(map);

    const marker = L.marker([position.lat, position.lng], { icon: emptyIcon }).addTo(map);
    marker.bindPopup("موقعیت ثبت شده").openPopup();

    return () => {
      map.remove();
    };
  }, [position]);

  return (
    <div
      ref={mapRef}
      style={{
        width: "100vw",
        height: "100vh",
      }}
    ></div>
  );
}
